"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M1 6c-.55 0-1 .45-1 1v4h.01L0 20c0 1.1.9 2 2 2h17c.55 0 1-.45 1-1s-.45-1-1-1H3c-.55 0-1-.45-1-1V7c0-.55-.45-1-1-1zm21-2h-8l-1.41-1.41c-.38-.38-.89-.59-1.42-.59H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.6 14.2l3.51-4.68c.2-.26.59-.27.8-.01l3.1 3.99 2.1-2.53c.2-.25.58-.24.78.01l2.49 3.2c.26.33.02.81-.39.81H8c-.41.01-.65-.46-.4-.79z"
}), 'PermMediaRounded');

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/PermMediaRounded.js
// module id = 4550
// module chunks = 0